// @ts-check
import BoostedOddItemModel from './boosted-odd-item.model';

export default class BoostedOddModel {
  /**
   * @param {import('./interfaces').TBoostedOdd} data - boostedOdds object
   */
  constructor(data) {
    const rawOdds = data.bo || [];
    /**
     * Boosted Odds
     * @type {BoostedOddItemModel[]}
     */
    this.odds = rawOdds.map(o => new BoostedOddItemModel(o));

    /**
     * Boosted Sports
     * @type {number[]}
     */
    this.sports = data.sf || [];
  }
}